/* tslint:disable */

import { ReaderFragment } from "relay-runtime";
import { FragmentRefs } from "relay-runtime";
export type SbSharedRefineMenuInputRangeCurrency_itemSearch = {
    readonly appliedFilters: ReadonlyArray<{
        readonly name: string | null;
    } | null> | null;
    readonly " $fragmentRefs": FragmentRefs<"SbSharedRefineMenuInputRange_itemSearch">;
    readonly " $refType": "SbSharedRefineMenuInputRangeCurrency_itemSearch";
};
export type SbSharedRefineMenuInputRangeCurrency_itemSearch$data = SbSharedRefineMenuInputRangeCurrency_itemSearch;
export type SbSharedRefineMenuInputRangeCurrency_itemSearch$key = {
    readonly " $data"?: SbSharedRefineMenuInputRangeCurrency_itemSearch$data;
    readonly " $fragmentRefs": FragmentRefs<"SbSharedRefineMenuInputRangeCurrency_itemSearch">;
};



const node: ReaderFragment = {
  "kind": "Fragment",
  "name": "SbSharedRefineMenuInputRangeCurrency_itemSearch",
  "type": "ItemSearchQueryConnection",
  "metadata": null,
  "argumentDefinitions": [],
  "selections": [
    {
      "kind": "LinkedField",
      "alias": null,
      "name": "appliedFilters",
      "storageKey": null,
      "args": null,
      "concreteType": "SearchBrowseParsedParam",
      "plural": true,
      "selections": [
        {
          "kind": "ScalarField",
          "alias": null,
          "name": "name",
          "args": null,
          "storageKey": null
        }
      ]
    },
    {
      "kind": "FragmentSpread",
      "name": "SbSharedRefineMenuInputRange_itemSearch",
      "args": null
    }
  ]
};
(node as any).hash = '5b5209934a174c24d6951bf82e480726';
export default node;
